import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ActivityService {


  static getActivity(item) {

    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

    let api = `${API_BASE_URL}${dynamicPaths.getActivity}`;
    const params = new URLSearchParams();

    if (item?.limit) params.append("limit", item.limit);
    if (item?.page) params.append("page", item.page);
    if (item?.id) params.append("id", item.id);
    if (item?.students) params.append("students", item.students);
    if (item?.teacherId) params.append("teacherId", item.teacherId);
    if ([...params].length > 0) {
      api += `?${params.toString()}`;
    }
    return axiosInstance
      .get(api, item)
  }


  static addActivity(data) {
    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
    let api = '';
    api = `${API_BASE_URL}${dynamicPaths.addActivity}`;
    return axiosInstance
      .post(api, data)
  }


  static deleteActivity(id) {
    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
    let api = '';
    api = `${API_BASE_URL}${dynamicPaths.deleteActivity}?id=${id}`;

    return axiosInstance
      .delete(api)
  }


}

export default ActivityService;
